module.exports = __webpack_public_path__ + "zoom.png?710afe1efa95ec7c399db8e40b55eba6";